/**
 * @params silence 接口报错时不弹窗提醒
 *
 * axios.get(url, { params, silence })
 * axios.post(url, data, { params, silence })
 */

import axios from 'axios';
import { Message } from 'element-ui';

const axiosConfig = {
  timeout: 30000,
  baseURL: process.env.VUE_APP_BASE_API,
};
if (process.env.NODE_ENV !== 'production') {
  axiosConfig.withCredentials = false;
}

const instance = axios.create(axiosConfig);

instance.interceptors.request.use(
  // eslint-disable-next-line arrow-body-style
  (config) => {
    return config;
  },
  error => Promise.reject(error),
);

instance.interceptors.response.use(
  (response) => {
    const { status, config, data } = response;

    if (status === 200) {
      return data;
    }

    if (!config.silence) {
      const msg = data.message || data.msg || '';
      Message.error(msg);
    }
    return Promise.reject(response);
  },

  (error) => {
    const {
      code, response, message, config,
    } = error;

    if (code === 'ECONNABORTED') {
      Message.error('请求超时，请重试');
      return Promise.reject(message);
    }

    if (!config.silence) {
      const msg = response.data.message || response.data.msg || '';
      Message.error(msg);
    }
    return Promise.reject(response);
  },
);

export default instance;
